<template>
  <div>
    <div class="container mt-3">
      <div class="row">
        <div class="col-12">
          <div class="text-center p-3">
            <img src="../../assets/img/digido-logo-350.png" alt="logo" class="img-fluid mb-5">
            <h1>Oops!</h1>
            <h2>404 Not Found</h2>
            <div class="text-danger mt-3">
              Sorry, an error has occured, Requested page not found!
            </div>
            <div class="mt-5">
              <a href @click="$router.back()" class="btn btn-primary btn-lg">Take Me Back</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '404',
  data () {
    return {};
  },
  methods: {},
  mounted () {},
  metaInfo: {
    title: '404'
  }
};
</script>
